module.exports = __webpack_public_path__ + "img/happy_customer.5b32b08d.jpg";